/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Current_PeriodInputs */

const en_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Period`)
};

const fr_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période actuelle`)
};

const de_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Periode`)
};

const it_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo corrente`)
};

const ru_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущий период`)
};

const es_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo actual`)
};

const zh_cn2_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本期`)
};

const ja_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当期`)
};

const hi_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान अवधि`)
};

const pt_pt2_usage_current_period = /** @type {(inputs: Usage_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período atual`)
};

/**
* | output |
* | --- |
* | "Current Period" |
*
* @param {Usage_Current_PeriodInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_current_period = /** @type {((inputs?: Usage_Current_PeriodInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Current_PeriodInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_current_period(inputs)
	if (locale === "de") return de_usage_current_period(inputs)
	if (locale === "it") return it_usage_current_period(inputs)
	if (locale === "ru") return ru_usage_current_period(inputs)
	if (locale === "es") return es_usage_current_period(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_current_period(inputs)
	if (locale === "ja") return ja_usage_current_period(inputs)
	if (locale === "hi") return hi_usage_current_period(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_current_period(inputs)
	return en_usage_current_period(inputs)
});